import { useEffect, useState } from "react";

import { Copy } from "lucide-react";

import { Button } from "../../../components/ui/button";
import { Checkbox } from "../../../components/ui/checkbox";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";

const DuplicateProjectDialog = ({ open, onOpenChange, project, onDuplicate }) => {
  const [duplicateName, setDuplicateName] = useState("");
  const [includeMilestones, setIncludeMilestones] = useState(true);
  const [includeTasks, setIncludeTasks] = useState(true);

  useEffect(() => {
    if (project) {
      setDuplicateName(`${project.name} (Copy)`);
    }
  }, [project]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onDuplicate({
      name: duplicateName,
      includeMilestones,
      includeTasks
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Copy className="w-5 h-5 text-primary" />
            Duplicate Project
          </DialogTitle>
          <DialogDescription>Create a copy of this project with selected data</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="dup_name">New Project Name *</Label>
            <Input
              id="dup_name"
              value={duplicateName}
              onChange={(e) => setDuplicateName(e.target.value)}
              placeholder="Enter new project name"
              required
            />
          </div>
          <div className="space-y-3 pt-2">
            <div className="flex items-center space-x-2">
              <Checkbox id="inc_milestones" checked={includeMilestones} onCheckedChange={setIncludeMilestones} />
              <label
                htmlFor="inc_milestones"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Include Milestones
              </label>
            </div>
            <div className="flex items-center space-x-2">
              <Checkbox id="inc_tasks" checked={includeTasks} onCheckedChange={setIncludeTasks} />
              <label
                htmlFor="inc_tasks"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Include Tasks
              </label>
            </div>
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
              Cancel
            </Button>
            <Button type="submit" variant="primary" className="flex-1">
              Duplicate Project
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default DuplicateProjectDialog;
